import React from "react";
import { ButtonGroup, styled, Typography, SxProps, Theme } from "@mui/material";
import { COLORS } from "components/consts";

const StyledButtonGroup = styled(ButtonGroup, {
    shouldForwardProp: (prop) => prop !== '$disabled'
})<{ $disabled?: boolean }>(({ $disabled }) => ({
    borderRadius: '30px',
    overflow: 'hidden',
    border: `1px solid ${$disabled ? COLORS.Romance50 : COLORS.Romance}`,
    width: '212px',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: '42px',
    opacity: $disabled ? 0.6 : 1,
}));

const StyledButton = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    cursor: 'pointer',
    textTransform: 'none',
    padding: '0px 14px',
    borderRadius: 30,
    border: 'none',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center',
    fontFamily: 'Inter',
    fontWeight: '600',
    '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.divider}`,
        border: 'none'
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        border: 'none',
        height: '32px',
    },
    '&:not(.Mui-selected)': {
        backgroundColor: 'transparent',
        color: COLORS.Romance50,
        border: 'none',
    },
    '&.disabled': {
        cursor: 'not-allowed',
        opacity: 0.6,
        pointerEvents: 'none',
    },
}));

interface ToggleButtonOption {
    value: string;
    label: string;
}

interface ToggleButtonGroupProps {
    options: ToggleButtonOption[];
    selectedValue: string;
    onValueChange: (value: string) => void;
    disabled?: boolean;
    width?: string;
    height?: string;
    sx?: SxProps<Theme>;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
    options,
    selectedValue,
    onValueChange,
    disabled = false,
    width = '212px',
    height = '42px',
    sx
}) => (
    <StyledButtonGroup
        sx={{ width, height, ...sx }}
        disabled={disabled}
        $disabled={disabled}
    >
        {options.map((option) => (
            <StyledButton
                key={option.value}
                className={`${selectedValue === option.value ? 'Mui-selected' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={disabled ? undefined : () => onValueChange(option.value)}
            >
                {option.label}
            </StyledButton>
        ))}
    </StyledButtonGroup>
); 